import React from 'react';
import PolicySignUp from './Steps/Policy';
import { useRegister } from '../../hooks/register';
import PasswordSignUp from './Steps/password';
import CpfSignUp from './Steps/cpf';
import RegisteredSignUp from './Steps/registered';
import LogosRow from '../BrandLogos';
import { StepsData } from '../../interfaces/StepsData';
import CompanySelection from './Steps/CompanySelection';
import EmailSignUp from './Steps/email';
import NameSignUp from './Steps/name';

const SignUp: React.FC = () => {
  const { step } = useRegister();

  const stepsVariations: StepsData = {
    privatePolicy: <PolicySignUp />,
    companySelection: <CompanySelection />,
    fillName: <NameSignUp />,
    fillCpf: <CpfSignUp />,
    fillEmail: <EmailSignUp />,
    fillPassword: <PasswordSignUp />,
    registered: <RegisteredSignUp />,
  };
  return (
    <>
      <LogosRow />
      {stepsVariations[step]}
    </>
  );
};

export default SignUp;
